import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-service-cloudsolution',
  templateUrl: './service-cloudsolution.component.html',
  styleUrls: ['./service-cloudsolution.component.css']
})
export class ServiceCloudsolutionComponent implements OnInit {

  //constructor(){}
  //commentted and new code added by Digvijay on 18-06-2019
  constructor(private meta: Meta,private titleService: Title) {
    this.meta.addTag({ name: 'description', content: 'Cloud Based Solutions ' },true);
    this.meta.addTag({ name: 'author', content: 'ShreeMon' },true);
    this.meta.addTag({ name: 'keywords', content: 'Cloud Based Solutions,Cloud-Based-Solutions' },true);    
    this.titleService.setTitle('Cloud Based Solutions | Shreemon');
  }

  ngOnInit() {
  }

}
